/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {defineCustomElement} from 'extensions/utils';
import styles from './list-controls.component.scss?as=stylesheet';
import 'extensions/ui-components/x-select';
import 'extensions/ui-components/x-search-results-count';
import 'extensions/ui-components/x-badge';

class ListControls extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			listType: {
				attribute: 'list-type',
				type: String
			},
			pagination: {
				type: Object
			},
			service: {
				state: true,
				type: Object
			},
			sorting: {
				type: Object
			},
			store: {
				state: true,
				type: Object
			}
		};
	}

	constructor () {
		super();
	}

	get compareList () {
		return this.store[this.listType]?.compareList || [];
	}

	get compareListActive () {
		return this.store[this.listType]?.compareListActive;
	}

	setCompareListActive (active) {
		if (this.store[this.listType]) {
			this.store[this.listType].setCompareListActive(active);
		}
	}

	handleSortChange (e) {
		// eslint-disable-next-line no-extra-parens
		const [target] = e.path || (e.composedPath && e.composedPath()) || [];

		this.service.sort(target.value);
	}

	handlePerPageChange (e) {
		// eslint-disable-next-line no-extra-parens
		const [target] = e.path || (e.composedPath && e.composedPath()) || [];

		this.service.perPage(target.value);
	}

	renderSortBy () {
		return html`
			<x-select label="Sort By" @change="${this.handleSortChange}" value="${this.sorting?.value}">
				${this.sorting?.options?.map(option => html`<option value="${option.value}" ?selected="${option.selected}">${option.title}</option>`)}
			</x-select>
		`;
	}

	render () {
		const resultsClasses = {
			'list-controls--active': !this.compareListActive,
			'list-controls--badge': true
		};

		const compareClasses = {
			'list-controls--active': this.compareListActive,
			'list-controls--badge': true,
			'list-controls--compare-hidden': !this.compareList?.length && !this.compareListActive
		};

		return html`
			<div class="list-controls list-controls--${this.listType}">
				<div class="list-controls--left">
					${this.pagination?.totalResults ? html`<x-badge class="${classMap(resultsClasses)}" @click="${() => this.setCompareListActive(false)}">
						<x-search-results-count
							page="${this.pagination?.page}"
							page-size="${this.pagination?.pageSize}"
							total="${this.pagination?.totalResults}"
						>
						</x-search-results-count>
					</x-badge>` : nothing}

					<x-badge class="${classMap(compareClasses)}" @click="${() => this.setCompareListActive(true)}">Compare (${this.compareList.length})</x-badge>
				</div>
				<div class="list-controls--right">
					${this.compareListActive ? nothing : this.renderSortBy()}
					<div class="list-controls--expert">
						<rb-chat-widget></rb-chat-widget>
					</div>
				</div>
			</div>
		`;
	}
};

defineCustomElement('rb-list-controls', ListControls);
